export default __webpack_public_path__ + "static/media/minpolicy.ec80603f.svg";